import React from "react";
import IconButton from "../IconButton";
import SelectedDays from "./SelectedDays";
import TimeSlots from "./TimeSlots";

const TimeWindow = ({
  onDeleteRow,
  selectedDays,
  setSelectedDays,
  timeSlots,
  setTimeSlots,
  minHoursOptionsRows,
  maxHoursOptionsRows,
  availableDays,
  firstDay,
  interval = 30,
}) => {
  return (
    <div className="w-full md:w-[50%] flex flex-col gap-4 md:flex-row items-start pb-4">
      <div className="w-full flex flex-row md:flex-col justify-between items-center md:items-start">
        <SelectedDays
          selectedDays={selectedDays}
          setSelectedDays={setSelectedDays}
          availableDays={availableDays}
          firstDay={firstDay}
        />
        <div className="md:hidden">
          <IconButton
            iconSize="size-5"
            icon={"/assets/icons/actions/delete.svg"}
            hoverIcon={"/assets/icons/actions/delete-hover.svg"}
            onClick={onDeleteRow}
          />
        </div>
      </div>
      <TimeSlots
        timeSlots={timeSlots}
        setTimeSlots={setTimeSlots}
        minHoursOptionsRows={minHoursOptionsRows}
        maxHoursOptionsRows={maxHoursOptionsRows}
        interval={interval}
      />
      <div className="hidden md:block ml-10 mt-2">
        <IconButton
          iconSize="size-5"
          icon={"/assets/icons/actions/delete.svg"}
          hoverIcon={"/assets/icons/actions/delete-hover.svg"}
          onClick={onDeleteRow}
        />
      </div>
    </div>
  );
};

export default TimeWindow;
